import { useEffect, useState } from 'react';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

declare global {
  interface Window {
    nham24?: {
      locale: 'en' | 'km' | 'zh';
      insets?: { top: number; bottom: number; left: number; right: number };
      platform?: 'android' | 'ios';
      // share?: (imageBase64: string) => void;
      request: (route: string, payload: any) => Promise<any>;
    };
    socketId: string;
  }
}

export default function useNativeSafeInsets() {
  const ins = useSafeAreaInsets();
  const [insets, setInsets] = useState(window?.nham24?.insets || { bottom: 0, left: 0, right: 0, top: 0 });

  useEffect(() => {
    if (!window?.nham24?.insets) {
      setInsets(ins);
    }
  }, []);
  return insets;
}
